import { useContext, useEffect } from 'react'
import { GlobalContext } from '../context/DataContext'

export const useBoundInfo = (map) => {
  const { showBounds } = useContext(GlobalContext)
  const [, setBounds] = showBounds

  useEffect(() => {
    if (!map) return undefined

    // Bounds from the heatmap route are not valid for a newly mounted home map.
    setBounds({})

    const updateBounds = () => {
      const mapBounds = map.getBounds()
      const mapCenter = map.getCenter()

      if (!mapBounds || !mapCenter) return

      const bounds = {
        ne: mapBounds.getNorthEast(),
        sw: mapBounds.getSouthWest()
      }
      const lastVisit = {
        zoom: map.getZoom() || 5,
        lat: mapCenter.lat() || 63.1304,
        lng: mapCenter.lng() || -96.3468
      }

      const serializedBounds = JSON.stringify(bounds)
      setBounds(serializedBounds)
      window.localStorage.setItem('lastBound', serializedBounds)
      window.localStorage.setItem('lastVisit', JSON.stringify(lastVisit))
    }

    const boundsListener = window.google.maps.event.addListener(
      map,
      'bounds_changed',
      updateBounds
    )
    const idleListener = window.google.maps.event.addListenerOnce(
      map,
      'idle',
      updateBounds
    )

    return () => {
      window.google.maps.event.removeListener(boundsListener)
      window.google.maps.event.removeListener(idleListener)
      setBounds({})
    }
  }, [map, setBounds])
}
